import { Trans, useTranslation } from 'react-i18next';
import { useStore } from '@hub/helpers/use-store';

const FundedModalContentTtp = () => {
  const {
    dataStore: { userStore, applicationConfigStore },
  } = useStore();
  const { t } = useTranslation(['contractModal']);
  const { termsAndConditions, privacyPolicy, tradingPracticesUrl } =
    applicationConfigStore.applicationConfig;

  const userName = `${userStore.currentUser.firstName || ''} ${
    userStore.currentUser.lastName || ''
  }`;

  const email = userStore.currentUser.email;

  return (
    <div className={'contracts-steps-body funded'}>
      <h3
        style={{
          textDecoration: 'underline',
          fontWeight: 600,
          textAlign: 'center',
        }}
      >
        {t('contractModal:funded_account_terms')}
      </h3>
      <p>
        <Trans
          ns="contractModal"
          i18nKey="funded_terms_eligibility"
          components={{ strong: <strong /> }}
        />
      </p>
      <p>
        <Trans
          ns="contractModal"
          i18nKey="funded_terms_notice"
          components={{
            a0: <a href={termsAndConditions} />,
            a1: <a href={privacyPolicy} />,
            strong: <strong />,
          }}
          values={{
            terms: '"Terms"',
          }}
        />
      </p>
      <span style={{ textDecoration: 'underline', fontWeight: 600 }}>
        {t('contractModal:funded_account')}
      </span>
      <p>
        <Trans
          ns="contractModal"
          i18nKey="company_shall_provide_trading_skills"
          components={{ strong: <strong /> }}
        />
      </p>
      <p>{t('contractModal:funded_user_monitoring')}</p>
      <p>{t('contractModal:funded_user_no_ownership')}</p>
      <p>{t('contractModal:funded_user_confidentiality')}</p>
      <p>
        <Trans
          ns="contractModal"
          i18nKey="funded_user_trading_rules"
          components={{
            a: <a />,
          }}
          values={{
            tradingPracticesUrl,
          }}
        />
      </p>
      <p>{t('contractModal:funded_user_trading_hours')} </p>
      <p>{t('contractModal:funded_user_position_flattening')}</p>
      <p>{t('contractModal:funded_user_violation')}</p>
      <p>{t('contractModal:funded_user_reassignment')}</p>
      <span style={{ textDecoration: 'underline', fontWeight: 600 }}>
        {t('contractModal:representations_warranties_covenants')}
      </span>
      <p>
        {t(
          'contractModal:funded_user_represents_warrants_covenants_to_company',
        )}
      </p>
      <p>{t('contractModal:user_acknowledges_and_agrees')}</p>
      <p>{t('contractModal:funded_user_no_investment_services')}</p>
      <p>{t('contractModal:funded_user_no_authorized_services')}</p>
      <p>{t('contractModal:funded_user_no_real_market_orders')}</p>
      <p>{t('contractModal:funded_user_no_performance_guarantee')}</p>
      <p>{t('contractModal:funded_user_account_cancellation')}</p>
      <p>{t('contractModal:funded_user_excessive_profits_review')}</p>
      <p>{t('contractModal:funded_user_has_necessary_knowledge')}</p>
      <p>{t('contractModal:funded_user_risk_parameters')}</p>
      <p>{t('contractModal:funded_user_black_swan_events')}</p>
      <p>{t('contractModal:funded_user_consistent_trading')}</p>
      <p>{t('contractModal:funded_user_legal_obligations')}</p>
      <p>{t('contractModal:funded_user_non_transferable_account')}</p>
      <p>{t('contractModal:funded_user_no_employment_relationship')}</p>
      <span style={{ textDecoration: 'underline', fontWeight: 600 }}>
        {t('contractModal:rewards')}
      </span>
      <p>{t('contractModal:funded_user_trading_rewards')}</p>
      <p>
        <span style={{ textDecoration: 'underline', marginLeft: '10px' }}>
          {t('contractModal:allocation')}
        </span>
        <Trans
          ns="contractModal"
          i18nKey="funded_user_reward_terms"
          components={{ strong: <strong /> }}
        />
      </p>
      <p>
        <span style={{ textDecoration: 'underline' }}>
          {t('contractModal:calculation_of_reward')}
        </span>{' '}
        <Trans
          ns="contractModal"
          i18nKey="trading_profit_loss_terms"
          components={{ strong: <strong /> }}
        />
      </p>
      <p>
        <span style={{ textDecoration: 'underline' }}>
          {t('contractModal:payout')}
        </span>{' '}
        {t('contractModal:payout_terms')}
      </p>
      <p>{t('contractModal:scaling_up')}</p>
      <p>{t('contractModal:withdrawal_method_selection')}</p>
      <p> {t('contractModal:prohibited_conduct')}</p>
      <span style={{ textDecoration: 'underline', fontWeight: 600 }}>
        {t('contractModal:termination_rights')}
      </span>
      <p>{t('contractModal:terms_application')}</p>
      <p>{t('contractModal:funded_account_termination')}</p>
      <p>{t('contractModal:funded_account_abandonment')}</p>
      <p>{t('contractModal:funded_account_false_statement')}</p>
      <span style={{ textDecoration: 'underline', fontWeight: 600 }}>
        {t('contractModal:data_and_use')}
      </span>
      <p>{t('contractModal:funded_user_acknowledgment_data_and_use')}</p>
      <span style={{ textDecoration: 'underline', fontWeight: 600 }}>
        {t('contractModal:acknowledgments')}
      </span>
      <p>{t('contractModal:funded_user_trading_terms')}</p>
      <span style={{ textDecoration: 'underline', fontWeight: 600 }}>
        {t('contractModal:binding_agreement_and_acknowledgement')}
      </span>
      <p>
        <Trans
          ns="contractModal"
          i18nKey="user_agreement_acknowledgment"
          components={{ strong: <strong /> }}
          values={{ userName, email }}
        />
      </p>
    </div>
  );
};

export default FundedModalContentTtp;
